export default __webpack_public_path__ + "static/media/bonus3.bd25a767.png";